import {Component, inject} from '@angular/core';
import {BaseComponent} from "../../shared/base/base-component";
import {NoDataComponent} from "../../shared/components/no-data/no-data.component";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [ NoDataComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent extends BaseComponent {

}
